export default {
    en: {
        boutonFermerDetailsOffre: 'Close',
        boutonOuvrirSRPrefix: 'See ',
        boutonOuvrirSRSuffix: ' mortgage details.',
        boutonLabelDetailsOffre: 'See mortgage details',
        boutonLabelDetailsChoixCoEmprunteur: 'See selected offer',

        titreFermeTauxFixe: ' closed fixed rate',
        titre5AnsFermeVariableReduit: '5-year closed reduced variable rate',
        titre5AnsFermeVariableProtege: '5-year closed protected variable rate',
        titre5AnsFermeRevisableAnnuellement:
            '5-year closed annually adjustable rate',

        // Section Caractéristiques
        titreSectionCaracteristique: 'Features',
        titreSectionCaracteristiques: 'Features',
        caracteristiqueAucuneVariation:
            'Rate stays the same throughout the term',
        caracteristiquesTauxBasePret1An:
            'Rate based on the 1-year fixed-rate mortgage minus a guaranteed spread',
        caracteristiquesTauxPaiementRevises:
            'Rate and payment adjusted each year',
        caracteristiquesConversionTauxFixe:
            'Convertible to a fixed-rate mortgage at any time without penalty',
        caracteristiquesTauxBaseTauxPreferentiel:
            'Rate based on the prime rate plus or minus a guaranteed spread',
        caracteristiquesPossibleVariation: 'Possible rate decrease or increase',
        caracteristiquesTauxPlafond:
            'Possible rate decrease or increase without exceeding the maximum rate (ceiling rate)',
        caracteristiquesTauxMaximumFixe:
            'Maximum rate established from the start',
        caracteristiquesPaiementsFixesEtablis:
            'Fixed payments based on the maximum rate',
        caracteristiquesConversionTauxVariable:
            'Protected variable rate can be converted to a fixed-rate mortgage at any time without penalty',
        caracteristiquesTauxBase1AnFerme:
            'Rate based on the 1-year fixed-rate mortgage minus a guaranteed spread',

        // Section Tolérance aux variations de taux
        titreSectionToleranceVariations: 'Tolerance for rate fluctuations',
        toleranceModereeElevee: 'Moderate to high',
        toleranceModeree: 'Moderate',
        toleranceFaible: 'Low',
        toleranceElevee: 'High',

        // Section Pourquoi le choisir?
        titreSectionPourquoiChoisir: 'Why choose it?',
        pourquoiEvitezSuprisesBudget:
            'You want to avoid sudden changes in your budget.',
        pourquoiPreferezFlexibiliteCourtTerme:
            'You prefer short-term flexibility to carry out future projects.',
        pourquoiPreferezFlexibiliteMoyenTerme:
            'You prefer medium-term flexibility to carry out future projects.',
        pourquoiPrevoyezConserverPropriete:
            'You plan to keep the property for at least {{frequence}}.',
        pourquoiPreferezTauxStable:
            'You prefer a rate that remains stable over one that can go up or down.',
        pourquoiEntrainerImportantesConsequences:
            'You understand that paying off your mortgage early can have significant unintended financial consequences. If needed, you’ll meet with your mortgage specialist for more details.',
        pourquoiPayerMoinsInteret:
            'You want to pay the least interest possible.',
        pourquoiPrevoyezConserver5ans:
            'You plan to keep the property for at least 5\xa0years.',
        pourquoiAucuneSurprise:
            'You know the maximum rate and regular payment amount from the start, and you won’t have any surprises.',
        pourquoiRemboursezCapitalPlusVite:
            'You pay off your principal quicker while the personalized rate is below the maximum rate.',
        pourquoiProfiterPotentiellesBaissesMaximum:
            'You want to take advantage of potential interest rate cuts, while being protected by the maximum rate.',
        pourquoiToleranceAuRisque:
            'You’re comfortable with risk but want your budget to be predictable in the short term.',
        pourquoiPaiementBaseAnnuelle:
            'You want to know the rate and the amount of your payments each year.',
        pourquoiProfiterPotentielleBaissesVariable:
            'You want to benefit from potential rate decreases and limit your exposure to the risks of rate fluctuations.',

        // Section Calcul taux personnalisé
        titreSectionCaculTauxPersonnalise: 'Calculating your personalized rate',
        calculEcartGarantiApplique:
            'We give you a guaranteed spread that is applied to the Desjardins prime rate for the duration of the term.',
        calculTauxPreferentielDesjardinsVarier:
            'The Desjardins prime rate may fluctuate and change your personalized rate.',
        calculTauxPreferentielDesjardinsProtege:
            'The Desjardins prime rate may fluctuate and change your personalized rate. Your rate is protected and will never exceed the maximum rate set at the start, no matter how the prime rate fluctuates.',
        calculEcartGarantiApplique1An:
            'Your rate is the same as the one on our 1-year closed fixed-rate mortgage, plus or minus a guaranteed spread. The percentage is available for each year of the term.',
        calculTauxReviseUneFoisParAn:
            'Your rate is adjusted once a year, on the anniversary date of the mortgage.',

        // Section Exemples de variations
        titreSectionExemplesVariations: 'Fluctuation examples',
        exemplesEcartGaranti: 'Guaranteed spread: {{ecart1}}.{{ecart2}}%',
        exemplesTauxMaximum: 'Maximum rate: {{taux1}}.{{taux2}}%',
        exemplesVotreTaux: 'Your rate: {{taux1}}.{{taux2}}%',
        exemplesAnneeVotreTaux: 'Personalized rate: {{taux1}}.{{taux2}}%',
        exemplesAnnee: 'Year\xa0{{annee}}',
        exemplesAnnee1: '1-year closed fixed mortgage rate: 4.99%',
        exemplesAnnee2: '1-year closed fixed mortgage rate: 4.99%',
        exemplesAnnee3: '1-year closed fixed mortgage rate: 5.24%',
        exemplesAnnee4: '1-year closed fixed mortgage rate: 4.74%',
        exemplesAnnee5: '1-year closed fixed mortgage rate: 4.49%',
        exemplesVariation: 'Fluctuation\xa0{{variation}}',
        exemplesTauxPreferentiel: 'Prime rate: {{taux1}}.{{taux2}}%',
        exemplesTauxPersonnalise: 'Personalized rate: {{taux1}}.{{taux2}}%'
    },
    fr: {
        boutonFermerDetailsOffre: 'Fermer',
        boutonOuvrirSRPrefix: 'Voir le détail du prêt ',
        boutonOuvrirSRSuffix: '.',
        boutonLabelDetailsOffre: 'Voir le détail du prêt',
        boutonLabelDetailsChoixCoEmprunteur: 'Voir l’offre choisie',

        titreFermeTauxFixe: ' fermé à taux fixe',
        titre5AnsFermeVariableReduit: '5\xa0ans fermé à taux variable réduit',
        titre5AnsFermeVariableProtege: '5\xa0ans fermé à taux variable protégé',
        titre5AnsFermeRevisableAnnuellement:
            '5\xa0ans fermé à taux révisable annuellement',

        // Section Caractéristiques
        titreSectionCaracteristique: 'Caractéristique',
        titreSectionCaracteristiques: 'Caractéristiques',
        caracteristiqueAucuneVariation:
            'Aucune variation du taux durant le terme',
        caracteristiquesTauxBasePret1An:
            'Taux basé sur celui du prêt 1\xa0an fermé à taux fixe moins un écart garanti',
        caracteristiquesTauxPaiementRevises:
            'Taux et paiement révisés chaque année',
        caracteristiquesConversionTauxFixe:
            'Conversion en taux fixe disponible en tout temps, sans frais d’indemnité',
        caracteristiquesTauxBaseTauxPreferentiel:
            'Taux basé sur le taux préférentiel plus ou moins un écart garanti',
        caracteristiquesPossibleVariation:
            'Possible variation du taux à la baisse ou à la hausse',
        caracteristiquesTauxPlafond:
            'Possible variation du taux à la baisse ou à la hausse sans dépasser le taux maximum (taux plafond)',
        caracteristiquesTauxMaximumFixe: 'Taux maximum fixé dès le départ',
        caracteristiquesPaiementsFixesEtablis:
            'Paiements fixes établis en fonction du taux maximum',
        caracteristiquesConversionTauxVariable:
            'Conversion du taux variable protégé en taux fixe disponible en tout temps, sans frais d’indemnité',
        caracteristiquesTauxBase1AnFerme:
            'Taux basé sur celui du prêt 1 an fermé à taux fixe moins un écart garanti',

        // Section Tolérance aux variations de taux
        titreSectionToleranceVariations: 'Tolérance aux variations de taux',
        toleranceModereeElevee: 'Modérée à élevée',
        toleranceModeree: 'Modérée',
        toleranceFaible: 'Faible',
        toleranceElevee: 'Élevée',

        // Section Pourquoi le choisir?
        titreSectionPourquoiChoisir: 'Pourquoi le choisir?',
        pourquoiEvitezSuprisesBudget:
            'Vous évitez les surprises dans votre budget.',
        pourquoiPreferezFlexibiliteCourtTerme:
            'Vous préférez la flexibilité à court terme pour réaliser de futurs projets.',
        pourquoiPreferezFlexibiliteMoyenTerme:
            'Vous préférez la flexibilité à moyen terme pour réaliser de futurs projets.',
        pourquoiPrevoyezConserverPropriete:
            'Vous prévoyez conserver la propriété au moins {{frequence}}.',
        pourquoiPreferezTauxStable:
            'Vous préférez un taux stable à un taux qui peut varier à la baisse ou à la hausse.',
        pourquoiEntrainerImportantesConsequences:
            'Vous comprenez que rembourser votre prêt avant la fin du terme pourrait entraîner d’importantes conséquences financières imprévues. Au besoin, vous consulterez votre spécialiste hypothécaire pour plus de précisions.',
        pourquoiPayerMoinsInteret:
            'Vous souhaitez payer le moins d’intérêt possible.',
        pourquoiPrevoyezConserver5ans:
            'Vous prévoyez conserver la propriété au moins 5\xa0ans.',
        pourquoiAucuneSurprise:
            'Vous connaissez le taux maximum et le paiement régulier dès le départ, et vous n’aurez aucune surprise.',
        pourquoiRemboursezCapitalPlusVite:
            'Vous remboursez votre capital plus vite tant que le taux personnalisé n’atteint pas le taux maximum.',
        pourquoiProfiterPotentiellesBaissesMaximum:
            'Vous souhaitez profiter de potentielles baisses de taux tout en restant protégé par le taux maximum.',
        pourquoiToleranceAuRisque:
            'Vous avez une certaine tolérance au risque, mais vous cherchez une prévisibilité à court terme dans votre budget.',
        pourquoiPaiementBaseAnnuelle:
            'Vous connaissez le taux et le montant de vos paiements sur une base annuelle.',
        pourquoiProfiterPotentielleBaissesVariable:
            'Vous voulez profiter des potentielles baisses de taux sans vous exposer pleinement aux risques d’un taux variable.',

        // Section Calcul taux personnalisé
        titreSectionCaculTauxPersonnalise: 'Calcul du taux personnalisé',
        calculEcartGarantiApplique:
            'Nous vous attribuons un écart garanti appliqué au taux préférentiel Desjardins pour la durée du terme.',
        calculTauxPreferentielDesjardinsVarier:
            'Le taux préférentiel Desjardins peut varier et modifier votre taux personnalisé.',
        calculTauxPreferentielDesjardinsProtege:
            'Le taux préférentiel Desjardins peut varier et modifier votre taux personnalisé. Votre taux est protégé et il ne dépassera jamais le taux maximum établi dès le départ, peu importe les variations du taux préférentiel.',
        calculEcartGarantiApplique1An:
            'Nous vous attribuons un écart garanti appliqué au prêt fermé à taux fixe sur 1\xa0an. Le pourcentage de cet écart est connu pour chaque année du terme.',
        calculTauxReviseUneFoisParAn:
            'Votre taux est révisé une fois par an, à la date anniversaire du prêt.',

        // Section Exemples de variations
        titreSectionExemplesVariations: 'Exemples de variations',
        exemplesEcartGaranti: 'Écart garanti\xa0: {{ecart1}},{{ecart2}}\xa0%',
        exemplesTauxMaximum: 'Taux maximum\xa0: {{taux1}},{{taux2}}\xa0%',
        exemplesVotreTaux: 'Votre taux\xa0: {{taux1}},{{taux2}}\xa0%',
        exemplesAnneeVotreTaux: 'Votre taux\xa0: {{taux1}},{{taux2}}\xa0%',
        exemplesAnnee: 'Année\xa0{{annee}}',
        exemplesAnnee1:
            'Taux du prêt fermé à taux fixe sur 1\xa0an : 4,99\xa0%',
        exemplesAnnee2:
            'Taux du prêt fermé à taux fixe sur 1\xa0an : 4,99\xa0%',
        exemplesAnnee3:
            'Taux du prêt fermé à taux fixe sur 1\xa0an : 5,24\xa0%',
        exemplesAnnee4:
            'Taux du prêt fermé à taux fixe sur 1\xa0an : 4,74\xa0%',
        exemplesAnnee5:
            'Taux du prêt fermé à taux fixe sur 1\xa0an : 4,49\xa0%',
        exemplesVariation: 'Variation\xa0{{variation}}',
        exemplesTauxPreferentiel:
            'Taux préférentiel\xa0: {{taux1}},{{taux2}}\xa0%',
        exemplesTauxPersonnalise:
            'Taux personnalisé\xa0: {{taux1}},{{taux2}}\xa0%'
    }
};
